import React from 'react';

function getShiurSuffix(message) {
  if (!message.shiur) {
    return '';
  }

  const parts = message.shiur.split(' ');
  return parts[parts.length - 1] || '';
}

function renderTitle(status) {
  if (status === 'חייל') {
    return 'לחייל האמיץ';
  }

  if (status === 'אברך') {
    return 'לאברך החשוב';
  }

  return null;
}

export default function BirthdayMessage({ message }) {
  const status = message['crfd1_status@OData.Community.Display.V1.FormattedValue'] || '';
  const shiurSuffix = getShiurSuffix(message);
  const hasStatus = status.trim() !== '';

  return (
    <div className="birthday-message">
      מזל טוב{' '}
      {renderTitle(status) ? (
        <>
          {renderTitle(status)}
          <br />
          <b className="birthday-message-name">
            {message.fullname}
            {shiurSuffix && ` (${shiurSuffix})`}
          </b>
          <br />
        </>
      ) : hasStatus ? (
        <>
          <br />
          ל
          {status === 'רב' && 'רב '}
          <b className="birthday-message-name">
            {message.fullname}
            {shiurSuffix && ` (${shiurSuffix})`}
          </b>
          <br />
        </>
      ) : (
        <>
          <br />
          <b className="birthday-message-name">
            {message.fullname}
            {shiurSuffix && ` (${shiurSuffix})`}
          </b>
          <br />
        </>
      )}
      לרגל יום ההולדת!
    </div>
  );
}
